import { useSalaryStaffCombo, useSalaryStaffInfo } from "hooks/apis/salary/useSalaryInfo";
import { useEffect, useState } from "react";
import SalaryEmployee from "./SalaryEmployee";

const INIT = {
  reason: "",
  salary_date: "",
  salary_deduct: 0,
  salary_report_id: "",
  salary_type: "",
  salary_type_list: [],
  staff_id: "",
  staff_info_list: [],
  staff_name_list: [],
};
const SalaryCurrentInfoView = ({
  onClickOpenModal,
  salaryReportId,
  is_edit,
  branchName,
  baseDate,
}) => {
  const [staffListInfo, setStaffListInfo] = useState(INIT);
  const [salaryOverallData, setSalaryOverallData] = useState();
  // API 상태 관리
  const querySalaryData = {
    salaryReportId,
    is_edit,
  };

  const { data: salaryOverall } = useSalaryStaffInfo(querySalaryData);
  const { data: salaryStaffCombo } = useSalaryStaffCombo(querySalaryData);

  // 받아 온 데이터 세팅
  useEffect(() => {
    if (salaryOverall) {
      setSalaryOverallData(salaryOverall.data);
    }
    if (salaryStaffCombo) {
      setStaffListInfo(salaryStaffCombo.data.data);
    }
  }, [salaryOverall, salaryStaffCombo]);

  return (
    <>
      {salaryOverallData ? (
        <SalaryEmployee
          staffListInfo={staffListInfo}
          salaryOverallData={salaryOverallData.data}
          onClickOpenModal={onClickOpenModal}
          finalTotalSalary={salaryOverallData.final_total_salary}
          salaryReportId={salaryReportId}
          is_edit={is_edit}
          branchName={branchName}
          baseDate={baseDate}
        />
      ) : (
        <></>
      )}
    </>
  );
};
export default SalaryCurrentInfoView;
